<template>
  <Modal>
    <Modal.Title class="mb-[18px]!">Add report credits</Modal.Title>

    <Modal.Body>
      <BuyReportCreditsBody
        v-model="selectedProductId"
        :loading="loading"
        :products="products"
      />
    </Modal.Body>

    <Modal.Footer layout="vertical">
      <Button
        variant="primary"
        size="lg"
        :disabled="!selectedProduct"
        @click="handleContinue"
      >
        Continue
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'

import BuyReportCreditsBody from './BuyReportCreditsBody.vue'
import { useBuyReportCredits } from '../useBuyReportCredits'

const props = defineProps<{ afterPurchase?: () => void }>()

const {
  loading,
  products,
  selectedProductId,
  selectedProduct,
  handleContinue,
} = useBuyReportCredits(props.afterPurchase)
</script>
